// extracted by mini-css-extract-plugin
var _1 = "NotificationMessage-module__actorMessage--vFeup";
export { _1 as "actorMessage" }
